/* eslint-disable no-else-return */
/** biome-ignore-all lint/suspicious/noDoubleEquals: TODO */

import { Switch } from '@gameday/react-components/components'
import RadioAdvanced from '@gameday/react-components/components/RadioAdvanced'
import theme, { rem } from '@gameday/react-components/utils/theme'
import { RadioGroup } from '@material-ui/core'
import { orderBy } from 'lodash'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { amountDisplay } from '../../../../formats'
import ToolTip from '../ToolTip'

export const renderInstalmentLine = (title, description, amount) => {
  const StyledWrapper = styled.div`
    display: flex;
    font-size: 12px;
    padding-bottom: 10px;
    font-family: ${theme.typography.defaultFont};

    span {
      line-height: 1.25;
    }
  `
  const StyledTitle = styled.span`
    color: ${theme.colors.darkGrey};
    font-weight: ${theme.typography.fontWeightBold};
    font-size: 12px;
    padding-right: 5px;
  `
  const StyledDescription = styled.span`
    color: ${theme.colors.darkGrey};
    font-weight: ${theme.typography.fontWeightNormal};
    font-size: 12px;
  `

  const StyledAmount = styled.span`
    color: ${theme.colors.darkGrey};
    font-weight: ${theme.typography.fontWeightNormal};
    font-size: 12px;
    margin-left: auto;
    margin-right: 5px;
  `

  return (
    <StyledWrapper>
      <StyledTitle>{title}</StyledTitle>
      <StyledDescription>{description}</StyledDescription>
      <StyledAmount>{(amount || '').replace(/\s+/g, '')}</StyledAmount>
    </StyledWrapper>
  )
}

const StyledPaymentGateway = styled.div`
  width: 100%;
  padding: ${rem(4)} 0 ${rem(20)};
  margin: 0 0 ${rem(16)};
  border-bottom: ${theme.borders.default};
  color: ${`var(--gameday-body-textColorLight, ${theme.body.textColorLight})`};

  > h3 {
    font-size: ${theme.typography.fontSizeBase};
    margin-bottom: 24px;
  }

  p {
    font-size: ${theme.typography.fontSizeTinyish};
    text-align: center;
  }

  .MuiRadio-colorPrimary.Mui-checked {
    color: ${props => props.buttonColour};
  }
  .radio-advanced:hover,
  .radio-advanced:focus,
  .radio-advanced.active {
    border-color: ${props => props.buttonColour};
  }

  label.radio-advanced {
    padding: 8px 16px !important;
  }
`

const StyledDivider = styled.hr`
  border: none;
  border-top: 1px solid #D9D9D9;
  margin: 0px 0px 10px 0px;
  width: 100%;
`

const PaymentGateway = ({
  gateways = [],
  total,
  onGatewayChange,
  onInstalmentUse,
  noDefault,
  buttonColour,
  formSettings,
  instalments,
}) => {
  const [paymentProvider, setPaymentProvider] = useState('')
  const [useInstalments, setUseInstalments] = useState(false)
  const sortedGateways = orderBy(gateways, ['orderNumber'])

  useEffect(() => {
    if (gateways && gateways.length > 0) {
      // set payment method in store
      const gateway = sortedGateways[0]
      if (!noDefault) {
        // if toggle for useInstalments is enabled AND the gateway has instalmentsGateway, then use instalmentsGateway as default.
        const sfid = useInstalments && !!gateway.instalmentsGateway ? gateway.instalmentsGateway : gateway.sfid
        onChooseGateway(sfid)
        setPaymentProvider(sfid)
      }
    }
  }, [])

  const onChooseGateway = (id, isInstalmentsPayment) => {
    const gateway = gateways.find(pg => pg.sfid === id || pg.instalmentsGateway === id)
    setPaymentProvider(id)
    onGatewayChange({
      type: (gateway.name || '').toLowerCase(),
      id,
      currency: gateway.currency,
      name: gateway.name,
      parentId: gateway.parentId,
      ...(gateway.name == 'Stripe' && {
        isInstalmentsPayment: typeof isInstalmentsPayment !== 'undefined' ? isInstalmentsPayment : useInstalments,
      }),
    })
  }

  const onChangeUseInstalments = (id, value) => {
    const newUseInstalments = value
    setUseInstalments(newUseInstalments)
    onInstalmentUse(newUseInstalments)
    onChooseGateway(id, newUseInstalments)
  }

  const canShowInstalments = ({ sfid, name, currency, instalmentsGateway }) => {
    if (name !== 'Stripe' || (!instalmentsGateway && paymentProvider !== sfid)) {
      return false
    }

    if (!formSettings.isInstalmentsEnabled || !instalmentsGateway) {
      return false
    }

    switch (currency) {
      case 'AUD':
      case 'NZD':
        return total >= 50
      case 'USD':
      case 'GBP':
      case 'EUR':
        return total >= 25
      case 'HKD':
        return total >= 250
    }

    return true
  }

  const renderInstalments = provider => {
    const { currency } = provider
    const { instalmentsCount } = formSettings

    const StyledHeading = styled.span`
      color: ${theme.colors.slate};
      font-family: ${theme.typography.defaultFont};
      font-weight: ${theme.typography.fontWeightBolder};
      text-align: left;
      display: block;
      padding-bottom: 10px;
      font-size: 12px;
    `
    const StyledContext = styled.span`
      color: ${theme.colors.darkGrey};
      word-wrap: break-word;
      word-break: break-word;
      white-space: normal;
      width: 100%;
      font-family: ${theme.typography.defaultFont};
      text-align: left;
      display: block;
      font-size: 12px;
      line-height: 1.5;
      margin-bottom: 10px;
    `
    const StyledWrapper = styled.div`
      display: flex;
      flex-direction: column;
    `

    const StyledWrapperFooter = styled.div`
      display: flex;
      flex-direction: row;
      padding-top: 10px;
    `

    const StyledTotal = styled.span`
      color: ${theme.colors.slate};
      font-family: ${theme.typography.defaultFont};
      font-weight: ${theme.typography.fontWeightBold};
      text-align: left;
      display: block;
      font-size: 12px;
      margin-left: auto;
      margin-right: 5px;
    `

    const totalAmount = instalments.reduce((sum, item) => sum + parseFloat(item.amountRaw), 0)

    return (
      <pre>
        <StyledHeading>Pay in Instalments</StyledHeading>
        <StyledContext>
          You have selected to pay for this order via an Instalment Payment Plan. By selecting this option you agree to
          the Instalment and Subscription Payment Agreement available{' '}
          <a href="https://mygameday.app/instalment-and-subscription-payment-agreement/" target="_blank" rel="noopener">
            here
          </a>
          . Your order total will be split into {instalmentsCount} equal payments using the payment method provided
          which will be stored against this order and charged on the dates outlined below:
        </StyledContext>
        <StyledDivider />
        <StyledWrapper>
          {instalments.map(({ title, description, amount }) => renderInstalmentLine(title, description, amount))}
        </StyledWrapper>
        <StyledDivider />
        <StyledWrapperFooter>
          <StyledTotal>Total: {amountDisplay(totalAmount, currency, false)}</StyledTotal>
        </StyledWrapperFooter>
      </pre>
    )
  }

  const instalmentTrigger = provider => {
    const StyledWrapper = styled.div`
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: flex-end;
    `

    const StyledSwitch = styled(Switch)`
      display: flex;
      align-items: center;
      color: red;
    `

    const StyledLabel = styled.div`
      color: ${theme.colors.slate};
      font-weight: ${theme.typography.fontWeightBolder};
      font-size: 12px;
      display: flex;
      align-items: center;
      margin-right: 10px;

      > div {
        margin-left: 0px;
      }
    `

    const StyledContent = styled.div`
      display: flex;
      flex-direction: column;
    `

    const tooltipContent = (
      <StyledContent>
        <p>
          <b>Instalment Payments</b> are subject to the Instalment and Subscription Payment Agreement available{' '}
          <a
            href="https://mygameday.app/instalment-and-subscription-payment-agreement/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: theme.colors.teal }}
          >
            here
          </a>
          .
        </p>
        <p>
          <b>Instalment Payment Plans</b> will be based on Total Order Amount, inclusive of all Products selected in the
          order and payable over {formSettings.instalmentsCount} equal instalment payments every{' '}
          {formSettings.instalmentsFrequency} {formSettings.instalmentsDelay} with the first instalment due on the
          original order date where an instalment payment plan has been selected as the desired payment method.
        </p>
      </StyledContent>
    )

    return (
      <StyledWrapper>
        <StyledSwitch
          customLabel={
            <StyledLabel>
              <span>Pay in Instalments</span>
              <ToolTip
                text={tooltipContent}
                arrow={true}
                leaveDelay={1000}
                leaveTouchDelay={1000}
                PopperProps={{
                  style: { pointerEvents: 'auto' },
                }}
              />
            </StyledLabel>
          }
          isChecked={useInstalments}
          onChecked={value => {
            const sfid = value ? provider.instalmentsGateway : provider.sfid
            onChangeUseInstalments(sfid, value)
          }}
          isLabelInline
        />
      </StyledWrapper>
    )
  }

  const instalmentsSummary = provider => {
    if (provider.name !== 'Stripe') {
      return
    }

    const StyledWrapper = styled.div`
      display: flex;
    `

    return useInstalments && <StyledWrapper>{<pre>{renderInstalments(provider)}</pre>}</StyledWrapper>
  }

  return (
    <>
      {gateways.length > 0 && Number(total) > 0 ? (
        <StyledPaymentGateway buttonColour={buttonColour}>
          <h3>Select Payment Method</h3>
          <RadioGroup
            defaultValue={gateways[0].sfid}
            name="payment"
            onChange={e => {
              const id = e.target.value
              onChooseGateway(id)
            }}
          >
            {sortedGateways.map((provider, index) => {
              const sfid = useInstalments && !!provider.instalmentsGateway ? provider.instalmentsGateway : provider.sfid

              const component = (
                <>
                  <RadioAdvanced
                    description={
                      (provider.name !== 'Stripe' || (provider.name === 'Stripe' && !canShowInstalments(provider))) &&
                      provider.paymentDescription
                    }
                    name="payment"
                    size={provider.name === 'PayPal' ? 'large' : 'small'}
                    value={sfid}
                    key={sfid}
                    checked={paymentProvider === sfid}
                    onClick={() => onChooseGateway(sfid)}
                    className={`radio-advanced ${paymentProvider === sfid && 'active'}`}
                    postFix={canShowInstalments(provider) && instalmentTrigger(provider)}
                    content={canShowInstalments(provider) && instalmentsSummary(provider)}
                  >
                    <div
                      // eslint-disable-next-line jam3/no-sanitizer-with-danger
                      // biome-ignore lint/security/noDangerouslySetInnerHtml: TODO
                      dangerouslySetInnerHTML={{
                        __html: provider.paymentLogoCode,
                      }}
                    />
                  </RadioAdvanced>
                </>
              )

              if (index === 0) {
                return (
                  <div key={provider.sfid}>
                    {component}
                    {gateways.length > 1 ? <p>or choose another payment method</p> : null}
                  </div>
                )
              }

              return component
            })}
          </RadioGroup>
        </StyledPaymentGateway>
      ) : null}
    </>
  )
}

export default PaymentGateway
